export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"charset":"utf-8"},{"name":"application-name","content":"Rail Monsters for Partners"},{"name":"description","content":"Partnership program for agencies"},{"name":"format-detection","content":"telephone=no"},{"name":"theme-color","content":"#ffffff"},{"name":"apple-mobile-web-app-title","content":"Rail Monsters for Partners"},{"property":"og:title","content":"Rail Monsters for Partners"},{"property":"og:description","content":"Partnership program for agencies"},{"property":"og:image","content":"https://partners.railmonsters.com/share.png"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"Rail Monsters for Partners"},{"name":"twitter:title","content":"Rail Monsters for Partners"},{"name":"twitter:description","content":"Partnership program for agencies"},{"name":"twitter:image","content":"https://partners.railmonsters.com/share.png"},{"name":"twitter:card","content":"summary_large_image"},{"name":"msapplication-TileColor","content":"#5B00CE"},{"name":"msapplication-TileImage","content":"https://partners.railmonsters.com/mstile-144x144.png"},{"name":"msapplication-square70x70logo","content":"https://partners.railmonsters.com/mstile-70x70.png"},{"name":"msapplication-square150x150logo","content":"https://partners.railmonsters.com/mstile-150x150.png"},{"name":"msapplication-wide310x150logo","content":"https://partners.railmonsters.com/mstile-310x150.png"},{"name":"msapplication-square310x310logo","content":"https://partners.railmonsters.com/mstile-310x310.png"}],"link":[{"rel":"shortcut icon","type":"image/x-icon","href":"https://partners.railmonsters.com/favicon.ico"},{"rel":"apple-touch-icon-precomposed","sizes":"57x57","href":"https://partners.railmonsters.com/apple-touch-icon-57x57.png"},{"rel":"apple-touch-icon-precomposed","sizes":"60x60","href":"https://partners.railmonsters.com/apple-touch-icon-60x60.png"},{"rel":"apple-touch-icon-precomposed","sizes":"72x72","href":"https://partners.railmonsters.com/apple-touch-icon-72x72.png"},{"rel":"apple-touch-icon-precomposed","sizes":"76x76","href":"https://partners.railmonsters.com/apple-touch-icon-76x76.png"},{"rel":"apple-touch-icon-precomposed","sizes":"114x114","href":"https://partners.railmonsters.com/apple-touch-icon-114x114.png"},{"rel":"apple-touch-icon-precomposed","sizes":"120x120","href":"https://partners.railmonsters.com/apple-touch-icon-120x120.png"},{"rel":"apple-touch-icon-precomposed","sizes":"144x144","href":"https://partners.railmonsters.com/apple-touch-icon-144x144.png"},{"rel":"apple-touch-icon-precomposed","sizes":"152x152","href":"https://partners.railmonsters.com/apple-touch-icon-152x152.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"https://partners.railmonsters.com/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://partners.railmonsters.com/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"https://partners.railmonsters.com/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"128x128","href":"https://partners.railmonsters.com/favicon-128.png"},{"rel":"icon","type":"image/png","sizes":"196x196","href":"https://partners.railmonsters.com/favicon-196x196.png"},{"rel":"manifest","href":"/manifest.json"}],"style":[],"script":[],"noscript":[],"title":"Rail Monsters for Partners","viewport":"width=device-width, initial-scale=1, maximum-scale=5","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false